module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"title":"Slipp løs<br> dine superkrefter","label":"Video"},"en":{"title":"Unleash<br> your superpowers","label":"Video"}}')
  delete Component.options._Ctor
}
